import axios from 'axios';
import apiConfig from '../../api.config';

export default function changePasswordRequest({ email, password, token, lang }) {
  const {
    host,
    URIs: { auth },
  } = apiConfig;

  const uri = `${host}${auth.changePassword}`;

  return axios
    .post(uri, JSON.stringify({ email, password, token, lang }), {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then(res => {
      return res.data;
    });
}
